'use strict';

import Collection from './collection.js';
import Employee from 'newModels/employee.js';
import TimeEntries from './time-entries.js';
import DefaultPayrollDetails from './default-payroll-details';
import moment from 'moment';

export default class Employees extends Collection {
    url() {
        if (this.employee) {
            return `${this.employee.url()}/managedEmployees`;
        }

        if (this.company) {
            return `${this.company.url()}/Employees`;
        }

        if (this.companyLocation) {
            return `${this.companyLocation.url()}/employees`;
        }

        return `/Employees`;
    }

    initialize(models, {
        company = null, employee = null, companyLocation = null
    } = {}) {
        super.initialize(...arguments);
        this.model = Employee;
        this.searchableAttributes = ['idStr', 'email', 'fullName'];
        this.company = company;
        this.employee = employee;
        this.companyLocation = companyLocation;

        if (!this.options.sortKey) {
            this.options.sortKey = 'canonicalFullName';
        }
        return this;
    }

    fetchTimeEntries(company, date = new Date()) {
        // we fetch only the current months entries -/+ 6 days in case
        // we are displaying a week that is partially in the previous or the
        // next month
        const monthStart = moment(date).startOf('month').add(-6, 'days');
        const monthEnd = moment(date).endOf('month').add(6, 'days');
        const employees = this.map(model => {
            model._timeEntries = new TimeEntries(null, {employee: model});
            return model;
        });
        const entries = new TimeEntries(null, {
            company: company,
            sortKey: 'payrollItemId',
            pagination: {rowsPerPage: 5000}
        });
        return entries.fetch({
            filter: {
                where: {
                    employeeId: {
                        inq: employees.map(
                            employee => employee.get('objectId')
                        )
                    },
                    and: [
                        {date: {lte: monthEnd}},
                        {date: {gte: monthStart}}
                    ]
                }
            }
        }).then(() => {
            entries.forEach(entry => {
                this.get(entry.get('employeeId'))._timeEntries.add(entry);
            });
        }).then(() => Promise.all(this.map(employee => {
            // Force add recurring OT
            const details = new DefaultPayrollDetails(
                null, {employee: employee}
            );
            return details.fetch({filter: {where: {hiddenAt: null}}})
                .then(() => {
                    const otDetails = details.filter(d => {
                        return d.getPayrollItem().get('type') === 'overtime';
                    });
                    const items = otDetails.map(d => d.getPayrollItem());
                    items.forEach(item => employee.getTimeEntry(date, item));
                });
        }))).then(() => this);
    }

    saveTimeEntries() {
        const timeEntries = new TimeEntries(null, {});
        this.forEach(employee => {
            timeEntries.add(employee._timeEntries.models);
        });
        return timeEntries.save();
    }

    dirtyTimeEntries() {
        const dirty = this.find(employee => {
            return employee._timeEntries.dirty();
        });
        return !!dirty;
    }
}



// WEBPACK FOOTER //
// ./app/new-collections/employees.js